import { nodeSchema } from '@hearth/shared';
import { ServerCog as ServerCogIcon } from 'lucide-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { NodeForm } from '@/components/node-form';
import { PageHeader } from '@/components/page-header';
import { apiRequest } from '@/lib/api';
import { applyServerErrors } from '@/lib/forms';

export const Route = createFileRoute('/_app/admin/nodes/new')({ component: NewNode });

function NewNode() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const create = useMutation({
    mutationFn: (body: unknown) =>
      apiRequest('/api/application/nodes', { method: 'POST', body, schema: nodeSchema }),
  });
  return (
    <>
      <PageHeader
        title="New node"
        icon={ServerCogIcon}
        description="After creating it, configure hearthd on the machine from the Configuration tab."
      />
      <NodeForm
        submitLabel="Create node"
        pending={create.isPending}
        initial={{ fqdn: '127.0.0.1', memoryMb: 8192, diskMb: 51_200 }}
        onSubmit={(values, setError) =>
          create.mutate(values, {
            onSuccess: async (node) => {
              await queryClient.invalidateQueries({ queryKey: ['admin', 'nodes'] });
              await navigate({
                to: '/admin/nodes/$nodeId',
                params: { nodeId: String(node.id) },
                search: { tab: 'configuration' },
              });
            },
            onError: (e) => applyServerErrors(e, setError),
          })
        }
      />
    </>
  );
}
